

// Imports ---------------------------------------------------------------------

// Nuxt / Vendor
import Vue from "vue";

// Project
import NavLogo from "~/components/NavLogo.vue";
import NavLinks from "~/components/NavLinks.vue";

// Export ----------------------------------------------------------------------

export default Vue.extend({

    // Component imports -------------------------------------------------------

    components: {
        NavLogo,
        NavLinks
    },

    // Component Internal Data State -------------------------------------------

    data: () => ({
        showNav: false,
        navBar: []
    }),

    // Component Computed Properties -------------------------------------------

    computed: {
        isActive (): object {
            return { "is-active": this.showNav };
        },

        menuLinks (): [] {
            return this.$store.state.navBar;
        },

        navbarClasses (): object {
            return ["navbar"];
        }
    },

    // Methods / Functions  ----------------------------------------------------

    methods: {
        toggleNav (): void {
            this.showNav = !this.showNav;
        }
    }

    // -------------------------------------------------------------------------
});
